import { Reducer } from 'redux';
import { SolicitacaoRetornoState, SolicitacaoRetornoTypes } from './types';

const INITIAL_STATE:  SolicitacaoRetornoState = {
  data: [],
  error: false,
  loading: false,
  radioSelecionado: undefined,
};

const reducer: Reducer<SolicitacaoRetornoState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SolicitacaoRetornoTypes.LOAD_SOLICITACAO_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SolicitacaoRetornoTypes.LOAD_SOLICITACAO_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
      };
    case SolicitacaoRetornoTypes.LOAD_SOLICITACAO_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };
    case SolicitacaoRetornoTypes.RADIO_SELECT:
      return {
        ...state,
        radioSelecionado: action.payload.radioSelecionado,
      }; 

    default:
      return state;
  }
};

export default reducer;